import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../PasswordProtectionUnlock.module.scss';
import { PublicImage } from '@/components/common/PublicImage/PublicImage';
import { TranslationKey } from '@/types/i18n.types';

interface IUnlockHeaderProps {
  readonly title: TranslationKey;
  readonly subtitle: TranslationKey;
}

export const UnlockHeader: React.FC<IUnlockHeaderProps> = ({
  title,
  subtitle,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <PublicImage
        className={styles.unlockImg}
        src="/images/blockpage/secure-password.svg"
        alt={t('blockPage.unlock.title')}
      />
      <div className={styles.unlockTitle}>{t(title)}</div>
      <div className={styles.unlockDescription}>{t(subtitle)}</div>
    </>
  );
};
